import Vue from 'vue'
import Router from 'vue-router'

// 路由加载

// 首页
import HomePage from '@/components/HomePage/HomePage'

// 布局
import Ui from '@/components/Ui/Ui'

// 工具栏
import Toolbar from '@/components/Toolbar/Toolbar'

// 素材区
import Material from '@/components/Material/Material'

// 场景
import Scene from '@/components/Scene/Scene'

// 动画时间轴
import EditorTimeline from '@/components/EditorTimeline/EditorTimeline'

// 动作时间轴
import ActionTimeline from '@/components/ActionTimeline/ActionTimeline'

// 动作
import Action from '@/components/Action/Action'

// 动作设置
import ActionInfo from '@/components/ActionInfo/ActionInfo'

// 部件
import Parts from '@/components/Parts/Parts'

// 属性
import Step from '@/components/Step/Step'

// 镜头
import Camera from '@/components/Camera/Camera'

// 文字
import Text from '@/components/Text/Text'

// 声音
import Audio from '@/components/AudioPanel/AudioPanel'

// 配音
import Record from '@/components/Record/Record'

// 背景音
import Bgm from '@/components/Bgm/Bgm'

// 分享播放器
import Share from '@/components/Share/Share'

// 模板
import Page from '@/components/Page/Page'

// 导出
import Export from '@/components/Export/Export'

//对齐
import Align from '@/components/Align/Align'

//登录
import Login from '@/components/Login/Login'

//AI生成
import SDUi from '../components/Ai/SDUi.vue'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        redirect: '/homepage'
    }, {
        path: '/homepage',
        component: HomePage
    }, {
        path: '/ui/:id',
        component: Ui
    }, {
        path: '/toolbar',
        component: Toolbar
    }, {
        path: '/Record',
        component: Record
    }, {
        path: '/material',
        component: Material
    }, {
        path: '/scene',
        component: Scene
    }, {
        path: '/editor-timeline',
        component: EditorTimeline
    }, {
        path: '/action-timeline',
        component: ActionTimeline
    }, {
        path: '/action',
        component: Action
    }, {
        path: '/actioninfo',
        component: ActionInfo
    }, {
        path: '/parts',
        component: Parts
    }, {
        path: '/step',
        component: Step
    }, {
        path: '/camera',
        component: Camera
    }, {
        path: '/text',
        component: Text
    }, {
        path: '/Audio',
        component: Audio
    }, {
        path: '/bgm',
        component: Bgm
    }, {
        path: '/share',
        component: Share
    }, {
        path: '/page',
        component: Page
    }, {
        path: '/export',
        component: Export
    }, {
        path: '/align',
        component: Align
    }, {
        path: '/login',
        component: Login
    }, {
        path: '/sdui',
        component: SDUi
    }],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js